module.exports = __webpack_public_path__ + "static/media/license.f77fb56b.svg";